// extracted by mini-css-extract-plugin
export default {"headline":"future_c8GoWta_UpgP"};